import { render, staticRenderFns } from "./ServiceOrderAddOperationsComponent.vue?vue&type=template&id=56cd37d2&"
import script from "./ServiceOrderAddOperationsComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderAddOperationsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports